export const emailStrings = {
  namePlaceholder: "Your name",
  emailPlaceholder: "Your email",
  messagePlaceholder: "Get in touch...",
  submitText: "Submit",
};
